import type { QueuedMutation } from './offlineQueue';
import type { QueueOwner } from './queueOwner';

const SET_REVIEWS_OP = 'SetSegmentReviews';

/** Clave estable del dueño de la sesión, para comparar con lo encolado. */
export function queueOwnerKey(owner: QueueOwner | undefined): string {
  return owner ? `${owner.userId}:${owner.tenantId}` : '';
}

/**
 * Marcas de «tramo revisado» que esperan en la cola offline: último estado
 * encolado por tramo (`true` = revisado, `false` = desmarcado).
 *
 * Se DERIVA de la cola, como `pendingSegmentsFromQueue`: no hay un segundo
 * almacén que vaciar al sincronizar; cuando el replay borra la operación, la
 * superposición desaparece sola. Solo cuentan las operaciones del dueño actual
 * (cuenta compartida) y la cola se recorre en su orden, así que gana la última.
 */
export function pendingSegmentReviewsFromQueue(
  entries: QueuedMutation[],
  ownerKey: string
): Map<string, boolean> {
  const pending = new Map<string, boolean>();
  if (!ownerKey) return pending;

  for (const entry of entries) {
    if (entry.operationName !== SET_REVIEWS_OP) continue;
    if (queueOwnerKey(entry.owner) !== ownerKey) continue;
    const { segmentIds, reviewed } = entry.variables as {
      segmentIds?: unknown;
      reviewed?: unknown;
    };
    if (!Array.isArray(segmentIds) || typeof reviewed !== 'boolean') continue;
    for (const id of segmentIds) {
      if (typeof id === 'string') pending.set(id, reviewed);
    }
  }
  return pending;
}
